import { render } from "./App.vue?vue&type=template&id=758968a0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=758968a0&lang=css"

import exportComponent from "/Volumes/jstChillin/Dropbox/pdc2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__